<div class="content">

  <button mat-fab class="pull-right" routerLink="/customer/new">
    <mat-icon class="md-24">add</mat-icon>
  </button>
  <app-data-table [class]="'table table-striped'" [model]="model" (rowClick)="navigate($event.customer.id)">
    <colgroup>
      <col class="col-md-1">
      <col class="col-md-4">
      <col class="col-md-4">
    </colgroup>
    <table-column label="ID">
      <ng-template table-column-content #col="content">
        <mat-chip-list>
          <mat-chip [style.backgroundColor]="col.record.category?.color">
            {{ col.record.id }}
          </mat-chip>
        </mat-chip-list>
      </ng-template>
    </table-column>
    <table-column label="Name">
      <ng-template table-column-content>
        {{ col.record.customer.name }}
      </ng-template>
    </table-column>
    <table-column label="Niederlassung / Ansprechperson">
      <ng-template table-column-content>
        {{ col.record.name }}
      </ng-template>
    </table-column>
    <table-column label="E-Mail">
      <ng-template table-column-content>
        {{ col.record.email }}
      </ng-template>
    </table-column>
    <table-column label="letzter Besuch">
      <ng-template table-column-content>
        {{ col.record.last_report != null ? (col.record.last_report | date) : 'noch nicht besucht' }}
      </ng-template>
    </table-column>

  </app-data-table>


</div>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/customer/customer.component.html